import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TaskErrorService {
    // Mapeo de razones de fallo técnicas a mensajes amigables
    private readonly friendlyErrorMessages: { [key: string]: string } = {
        'TASK_NOT_FOUND': 'La tarea no fue encontrada o ya no existe.',
        'PERMISSION_DENIED': 'No tienes permisos para realizar esta acción en la tarea.',
        'INVALID_STATUS_TRANSITION': 'No se puede cambiar el estado de esta tarea al solicitado.',
        'TASK_ALREADY_COMPLETED': 'La tarea ya estaba completada.',
        'TASK_ALREADY_CANCELLED': 'La tarea ya estaba cancelada.',
        'DUE_DATE_IN_PAST': 'La fecha de vencimiento no puede ser en el pasado.',
        'TASK_IS_PROTECTED': 'La tarea está protegida y no permite esta acción.',
        'PARENT_TASK_NOT_FOUND': 'La tarea padre no fue encontrada.',
        'SUBTASK_EXISTS': 'No se puede eliminar la tarea porque tiene subtareas asociadas.',
        'DEPENDENCY_EXISTS': 'No se puede eliminar la tarea porque es una dependencia de otra.',
        'INVALID_CANCEL_REASON': 'El motivo de cancelación no es válido.',
        'INVALID_DUE_DATE': 'La fecha de vencimiento proporcionada no es válida.',
    };

    /**
     * Obtiene un mensaje amigable basado en el error del backend.
     * Busca primero por el campo 'code' del error, luego por 'message'.
     * @param err El objeto de error recibido de la API.
     * @param fallback Mensaje por defecto si no se encuentra mapeo.
     */
    getFriendlyMessage(err: any, fallback = 'Ocurrió un error inesperado.'): string {
        const code = err?.error?.code;
        if (code && this.friendlyErrorMessages[code]) {
            return this.friendlyErrorMessages[code];
        }
        // Si no hay código mapeado, intentamos usar el mensaje directo del backend
        // o el texto estático proporcionado como respaldo.
        return err?.error?.message || fallback;
    }
}